module.exports = __webpack_public_path__ + "static/media/sergo-shop.91ca16e4.jpg";